<template>
  <div class="relative">
    <clear-icon
      v-if="isClearable"
      alt="clear icon"
      class="clear-icon"
      @click.native="clearInput"
    />
    <input
      :placeholder="placeholder ? placeholder : $t('search')"
      class="search-input"
      :id="id"
      v-model="searchedText"
      :class="[customClass, inputSize, inputRadius]"
    />
    <search-icon class="search-icon" />
  </div>
</template>
<script>
import debounce from 'lodash.debounce';
import SearchIcon from '@/assets/icons/vue/search_normal.vue';
import ClearIcon from '@/assets/icons/vue/close_normal.vue';
import EventBus from '@/utils/EventBus';

export default {
  name: 'BaseSimpleSearchBox',
  components: {
    ClearIcon,
    SearchIcon,
  },
  props: {
    inputValue: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '275',
    },
    height: {
      type: String,
      default: '32',
    },
    radius: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      required: true,
    },
    customStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isClearable: false,
      searchedText: '',
    };
  },
  mounted() {
    EventBus.$on('emptyInputValue', () => {
      this.searchedText = '';
    });
  },
  watch: {
    searchedText:
      // eslint-disable-next-line func-names
      debounce(function () {
        this.isClearable = !!this.searchedText;
        this.$emit('searchedIn', this.type);
        this.$emit('searchedText', this.searchedText);
      }, 300),
  },
  computed: {
    customClass() {
      return this.customStyle ? this.customStyle : 'input';
    },
    inputSize() {
      return `w-${this.width} h-${this.height}`;
    },
    inputRadius() {
      return this.radius ? `rounded-${this.radius}` : 'rounded';
    },
  },
  methods: {
    clearInput() {
      this.searchedText = '';
    },
  },
};
</script>

<style lang="css" scoped>
.search-input {
  @apply border bg-secondary border-default px-36 text-subtitle
    focus:outline-none focus:border-active;
}
.search-icon {
  @apply absolute top-1/4 left-12;
}
.clear-icon {
  @apply absolute top-16 right-12 hover:cursor-pointer;
}
.search-icon:is(:lang(fa), :lang(ar)) {
  @apply left-auto right-12;
}
.clear-icon:is(:lang(fa), :lang(ar)) {
  @apply right-auto left-12;
}
input::placeholder {
  @apply text-subtitle;
}
</style>
